import { RegisterResponse } from '../../../../../types/api/endpoints/auth/register.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';

const PREFIX = '[registerDocumentQuery]';

export const REGISTER_DOCUMENT_QUERY_KEY = 'REGISTER_DOCUMENT';

export const queryUploadDocPUB = async (data: FormData) => {
  console.log(PREFIX, `Requesting doc PUB uploading...`);

  const response = await AUTH_ENDPOINTS.documentPUB(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received doc PUB response.`);
  return json as RegisterResponse;
};
